module.exports = __webpack_public_path__ + "public/media/ic_check_circle_blue.556c5c0c.svg";